export function createCachedJsonFetcher() {
  const cache = new Map();

  async function load({
    url,
    refetch = false,
  }: {
    url: string;
    refetch?: boolean;
  }) {
    if (!refetch && cache.get(url)) return cache.get(url);

    const response = await fetch(url);
    const data = await response.json();
    cache.set(url, data);
    return data;
  }

  return { load };
}
